import styled from 'styled-components';
import { motion } from 'framer-motion';


export const AboutContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
`;

export const AboutHero = styled(motion.div)`
  position: relative;
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  overflow: hidden;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }
    &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); // Black overlay with opacity
    z-index: 1;
  }

  & > div {
    position: relative;
    z-index: 1;
  }
`;

export const AboutContent = styled.div`
  max-width: 1200px;
  margin: 4rem auto;
  padding: 0 2rem;
  p:last-of-type {
    text-align: center;
    font-style: italic;
    font-size: 18px;
  }
`;

export const AboutSection = styled(motion.section)`
  margin-bottom: 4rem;
`;

export const StatsGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin: 4rem 0;
  text-align: center;
`;

export const StatItem = styled(motion.div)`
  .number {
    font-size: 3rem;
    font-weight: bold;
    color: #007bff;
  }
  .label {
    font-size: 1.2rem;
    color: #666;
  }
`;

export const TeamGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
  margin-top: 3rem;
`;

export const TeamMember = styled(motion.div)`
  text-align: center;
  
  .image-container {
    width: 250px;
    height: 250px;
    margin: 0 auto 2rem;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
    
    &:hover img {
      transform: scale(1.1);
    }
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }

  h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .position {
    color:rgb(68, 0, 255);
    margin-bottom: 1rem;
  }

  .description {
    color: #666;
    line-height: 1.6;
  }
`;

export const teamData = [
  {
    id: 1,
    name: "JuanFra Hernandez",
    position: "Programador y experto SEO",
    image: "/images/juanfra.png",
    description: "Diseño soluciones digitales con propósito, que impulsan marcas y conectan con personas."
  },
  {
    id: 2,
    name: "Aurora Zamora",
    position: "Diseño y creación de Marca",
    image: "/images/aurora.png",
    description: "Diseño marcas y espacios que cuentan historias y transmiten su esencia, quiénes son y cómo quieren ser percibidas",
    website: "https://estudiozao.es/"
  },
 ];

export const companyStats = [
  { number: "100+", label: "Proyectos Completados" },
  { number: "50+", label: "Clientes Satisfechos" },
  { number: "8+", label: "Años de Experiencia" },
  
];